import React, { useEffect, useState } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { getNoticeImageUrl } from "../Helpers";
import "./ActiveNoticeModal.css";

function ActiveNoticeModal() {
  const [show, setShow] = useState(false);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const checkAndFetchNotice = async () => {
      try {
        // Show only 1 time in admin panel per user login session
        const alreadyShown = sessionStorage.getItem("admin_notice_shown");
        if (alreadyShown === "true") {
          return;
        }

        const token = localStorage.getItem("token");
        if (!token) {
          return;
        }

        const response = await axios.get("/get/notice", {
          headers: { token: token },
        });

        const resData = response?.data;
        let activeMessage = "";
        let activeImage = null;
        let noticeDate = null;
        let noticeId = null;

        // Handle various response data shapes
        if (resData?.activeNotice) {
          activeMessage = resData.activeNotice.message || "";
          activeImage = resData.activeNotice.image || null;
          noticeDate = resData.activeNotice.created_at || resData.activeNotice.updated_at;
          noticeId = resData.activeNotice._id;
        } else if (Array.isArray(resData?.data)) {
          const active = resData.data.find((item) => item.status === "active");
          if (active) {
            activeMessage = active.message || "";
            activeImage = active.image || null;
            noticeDate = active.created_at || active.updated_at;
            noticeId = active._id;
          }
        } else if (typeof resData?.data === "string" && resData.data.trim()) {
          activeMessage = resData.data;
        } else if (resData?.data && typeof resData.data === "object") {
          if (resData.data.status === "active" || !resData.data.status) {
            activeMessage = resData.data.message || "";
            activeImage = resData.data.image || null;
            noticeDate = resData.data.created_at;
            noticeId = resData.data._id;
          }
        }

        // Mark as shown for this login session
        sessionStorage.setItem("admin_notice_shown", "true");

        const hasContent = (activeMessage && activeMessage.trim().length > 0) || Boolean(activeImage);

        if (hasContent) {
          setNotice({
            message: activeMessage ? activeMessage.trim() : "",
            image: activeImage,
            date: noticeDate,
            id: noticeId,
          });
          setShow(true);
        }
      } catch (error) {
        console.error("Notice check failed:", error);
      }
    };

    checkAndFetchNotice();
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  if (!notice || (!notice.message && !notice.image)) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      backdrop="static"
      keyboard={true}
      className="notice-modal"
    >
      <div className="notice-modal-header">
        <div className="notice-header-left">
          <div className="notice-icon-box">
            <i className="ti-announcement"></i>
          </div>
          <div className="notice-title-wrap">
            <div className="notice-pill-badge">
              <span className="notice-pulse-dot"></span>
              Active Announcement
            </div>
            <h5 className="notice-header-title">Notice</h5>
          </div>
        </div>
        <button
          type="button"
          className="notice-close-btn"
          onClick={handleClose}
          aria-label="Close"
        >
          &times;
        </button>
      </div>

      <div className="notice-modal-body">
        {notice.image && (
          <div className="notice-image-container">
            <a
              href={getNoticeImageUrl(notice.image)}
              target="_blank"
              rel="noopener noreferrer"
              className="notice-image-link"
              title="Click to view full image in a new tab"
            >
              <img
                src={getNoticeImageUrl(notice.image)}
                alt="Notice Announcement"
                className="notice-popup-image"
              />
              <span className="notice-image-zoom-badge">
                <i className="ti-fullscreen me-1"></i> View Full Image
              </span>
            </a>
          </div>
        )}

        {notice.message && (
          <div className="notice-message-container">
            <p className="notice-message-content">{notice.message}</p>
          </div>
        )}

        <div className="notice-meta-info">
          {notice.date ? (
            <span className="notice-date">
              <i className="ti-calendar"></i>
              Posted: {moment(notice.date).format("DD MMM YYYY, hh:mm A")}
            </span>
          ) : (
            <span></span>
          )}
          <span className="notice-login-indicator ms-auto">
            <i className="ti-info-alt"></i>
            Notice for this session
          </span>
        </div>
      </div>

      <div className="notice-modal-footer">
        <button
          type="button"
          className="notice-confirm-btn"
          onClick={handleClose}
        >
          <i className="ti-check"></i>
          I Understand
        </button>
      </div>
    </Modal>
  );
}

export default ActiveNoticeModal;
